/**
 * How many words the edit sheet lets a person ADD on one axis — «Слова в
 * описании» and «Не присылать тендеры со словами».
 *
 * Deliberately lower than what the API accepts (`SAVED_SEARCH_TERMS_ACCEPTED_MAX`
 * = 50 in `services/api/.../saved-search-term-limits.ts`): a search that support
 * set up with more words than this must still SAVE — the sheet re-sends the
 * whole list on every edit — so the form only stops offering to add more.
 * While both numbers were 10, every such search answered 400 to any edit.
 *
 * Its own module, not an export of `saved-search-client`: a dozen test files
 * replace that client wholesale with `vi.mock`, and a constant living there
 * would be `undefined` in every one of them.
 */
export const SAVED_SEARCH_TERMS_MAX = 20;
